import { createToolItem } from '../settlement/factory';
import { addInventory, addTools } from '../settlement/manager';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const cancelConstructionAction =
    (constructionId: string): ModalActionHandler =>
    (state, modal) => {
        const settlement = getSettlement(state, modal);
        if (!settlement) return false;
        const index = settlement.construction.queue.findIndex((item) => item.id === constructionId);
        if (index < 0) return false;
        const item = settlement.construction.queue[index];
        if (!item) return false;

        const refundConfig = state.config.construction.refund;
        if (!refundConfig.allowInProgress && item.work > 0) return false;

        const percent = Math.max(0, refundConfig.percent);
        if (percent > 0) {
            const ratio = percent / 100;
            Object.entries(item.cost || {}).forEach(([key, amount]) => {
                const refund = Math.floor(amount * ratio);
                if (refund <= 0) return;
                if (key === 'tools') {
                    const tools = Array.from({ length: refund }, () => createToolItem(settlement));
                    addTools(settlement, tools);
                    return;
                }
                addInventory(
                    settlement,
                    key as keyof Omit<typeof settlement.inventory, 'tools'>,
                    refund,
                );
            });
        }

        settlement.construction.queue.splice(index, 1);
        return true;
    };
